import { Form_PropertyBooleanInput } from './Form_PropertyBooleanInput';
import { Form_PropertyEnumInput } from './Form_PropertyEnumInput';
import { Form_PropertyIntegerInput } from './Form_PropertyIntegerInput';
import { Form_PropertyMultilineInput } from './Form_PropertyMultilineInput';
import { Form_PropertyNameInput } from './Form_PropertyNameInput';
import { Form_PropertyStringInput } from './Form_PropertyStringInput';
import {Form_PropertyDateTimeInput} from "./Form_PropertyDateTimeInput";
import { From_PropertyColorPicker } from './From_PropertyColorPicker';

export const PropertyInputs = {
    Boolean: Form_PropertyBooleanInput,
    Enum: Form_PropertyEnumInput,
    Integer: Form_PropertyIntegerInput,
    String: Form_PropertyStringInput,
    Name: Form_PropertyNameInput,
    MultilineString: Form_PropertyMultilineInput,
    Date: Form_PropertyDateTimeInput,
    Color: From_PropertyColorPicker,
};
